export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <img
              src="https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/a34b1e0ab002dc04c0156491411f9278.jpeg"
              alt="King Square Club"
              className="h-20 w-20 object-contain mb-4"
            />
            <p className="text-white/70 text-sm leading-relaxed">
              Benin City's premier luxury nightclub. Experience the ultimate in entertainment, elegance, and exclusivity.
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold text-base mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-white/70 hover:text-amber-400 text-sm transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('events')}
                  className="text-white/70 hover:text-amber-400 text-sm transition-colors cursor-pointer"
                >
                  Events
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-white/70 hover:text-amber-400 text-sm transition-colors cursor-pointer"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white/70 hover:text-amber-400 text-sm transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-amber-400 text-sm transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-base mb-4">Connect With Us</h3>
            <div className="flex space-x-3 mb-4">
              <a
                href="https://www.instagram.com/kingsquareclub"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-800 hover:bg-amber-500 rounded-full flex items-center justify-center text-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.snapchat.com/add/kingsquareclub"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-800 hover:bg-amber-500 rounded-full flex items-center justify-center text-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-snapchat-line text-lg"></i>
              </a>
              <a
                href="https://www.tiktok.com/@kingsquareclub"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-800 hover:bg-amber-500 rounded-full flex items-center justify-center text-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a
                href="https://wa.me/2349039844951"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-800 hover:bg-amber-500 rounded-full flex items-center justify-center text-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
            <p className="text-white/70 text-sm">
              148 Airport Rd, Benin City 300102, Edo<br />
              Open: Fri – Sun | 11PM – 5AM
            </p>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-8 text-center">
          <p className="text-white/50 text-sm">
            © 2026 King Square Club. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}